<script lang="ts">
  export let tags;
  export let value;
  export let checked;

  $: updateChekbox(tags);
  $: updateGroup(checked);

  function updateChekbox(tags) {
    checked = tags.indexOf(value) >= 0;
  }

  function updateGroup(checked) {
    const index = tags.indexOf(value);
    if (checked) {
      if (index < 0) {
        tags.push(value);
        tags = tags;
      }
    } else {
      if (index >= 0) {
        tags.splice(index, 1);
        tags = tags;
      }
    }
  }

  function decamelize(str, separator) {
    separator = typeof separator === "undefined" ? "_" : separator;

    const label = str
      .replace(/([a-z\d])([A-Z])/g, "$1" + separator + "$2")
      .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1" + separator + "$2")
      .replace(/^./, str[0].toUpperCase());

    if (str === "video" || str === "image") {
      return `${label} Background`;
    }
    return label;
  }

  const label = decamelize(value, " ");
</script>

<label>
  <input type="checkbox" bind:checked {value} />
  {label}
</label>

<style>
  label {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
  }
</style>
